import { render, staticRenderFns } from "./AGB.vue?vue&type=template&id=2530b82d&"
import script from "./AGB.vue?vue&type=script&lang=js&"
export * from "./AGB.vue?vue&type=script&lang=js&"
import style0 from "./AGB.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports